import { useEffect, useRef, useState } from "react";
import { asset } from "../lib/asset";

/** Muted looping clip with a poster; pauses off-screen and under reduced motion. */
export function LoopVideo({ src, poster, className = "", alt = "" }: { src?: string; poster: string; className?: string; alt?: string }) {
  const ref = useRef<HTMLVideoElement>(null);
  const [failed, setFailed] = useState(!src);
  const reduced = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  useEffect(() => {
    const v = ref.current;
    if (!v || reduced) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) void v.play().catch(() => undefined);
        else v.pause();
      },
      { threshold: 0.15 },
    );
    io.observe(v);
    return () => io.disconnect();
  }, [reduced, failed]);
  if (failed || reduced)
    return <img src={asset(poster)} alt={alt} className={className} draggable={false} onError={(e) => ((e.target as HTMLImageElement).style.visibility = "hidden")} />;
  return (
    <video
      ref={ref}
      className={className}
      src={asset(src!)}
      poster={asset(poster)}
      muted
      loop
      playsInline
      autoPlay
      preload="metadata"
      aria-label={alt || undefined}
      onError={() => setFailed(true)}
    />
  );
}
